import { Dispatch, SetStateAction } from "react";
import { EditFields } from "..";
import { Box } from "src/components/MuiGenerals";
import { TableRow } from "src/views/Ledger/LedgerBalanceMonitor/types/Table";
import InfoFieldSection from "./components/InfoFieldSection";
import AlertTypeSection from "src/views/Ledger/LedgerBalanceMonitor/components/Common/AlertTypeSection";
import BalanceIntervalSection from "src/views/Ledger/LedgerBalanceMonitor/components/Common/BalanceIntervalSection";
import ThresholdFieldSection from "src/views/Ledger/LedgerBalanceMonitor/components/Common/ThresholdFieldSection";

function Content({
  rowData,
  setFields,
  fields,
  isLowerThresholdInvalid,
  isUpperThresholdInvalid,
}: {
  rowData: TableRow;
  setFields: Dispatch<SetStateAction<EditFields>>;
  fields: EditFields;
  isLowerThresholdInvalid: boolean;
  isUpperThresholdInvalid: boolean;
}) {
  return (
    <Box
      sx={{
        ".MuiInputLabel-shrink": {
          display: "none",
        },
      }}
    >
      <InfoFieldSection rowData={rowData} />

      <hr style={{ opacity: 0.5, marginTop: "30px", marginBottom: "24px" }} />

      <AlertTypeSection fields={fields} setFields={setFields} />

      <br />

      <BalanceIntervalSection
        fields={fields}
        setFields={setFields}
        chainName={rowData.chain_code}
        currency={rowData.currency}
        clientId={rowData.client_id}
      />

      <br />

      <ThresholdFieldSection
        fields={fields}
        setFields={setFields}
        isLowerThresholdInvalid={isLowerThresholdInvalid}
        isUpperThresholdInvalid={isUpperThresholdInvalid}
        helperTextKey="fixed_threshold_message"
        dynamicHelperTextKey="edit_dynamic_threshold_message"
      />
    </Box>
  );
}

export default Content;
